import { render, staticRenderFns } from "./MoHeader.vue?vue&type=template&id=48ab5182&scoped=true&"
import script from "./MoHeader.vue?vue&type=script&lang=js&"
export * from "./MoHeader.vue?vue&type=script&lang=js&"
import style0 from "./MoHeader.vue?vue&type=style&index=0&id=48ab5182&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab5182",
  null
  
)

export default component.exports